import type { GridCustomCellProps } from "@tql/ui-components-react/kendo/grid";
import { Button } from "@tql/ui-components-react/tql/buttons";
import { edit_05, trash_01 } from "@tql/ui-components-react/untitled/icons";
import { useMemo } from "react";

import { GridTd } from "~/shared/components/trax-grid/grid-td/grid-td.tsx";
import type { TraxUser } from "~/shared/schemas/trax-user-schema.ts";
import type { BoardColumn } from "~/shared/types/quote-board-types.ts";

type UseVendorColumnsOptions = {
	onEdit: (user: TraxUser) => void;
	onDelete: (user: TraxUser) => void;
	canManageVendors: boolean;
};

export const useVendorColumns = ({
	onEdit,
	onDelete,
	canManageVendors,
}: UseVendorColumnsOptions) => {
	const columns: BoardColumn[] = useMemo(
		() => [
			{
				field: "firstName",
				title: "First Name",
				show: true,
				width: "250px",
				editable: false,
			},
			{
				field: "lastName",
				title: "Last Name",
				show: true,
				width: "250px",
				editable: false,
			},
			{
				field: "email",
				title: "Email",
				show: true,
				width: "250px",
				editable: false,
			},
			// {
			// 	field: "role",
			// 	title: "Permission Level",
			// 	show: true,
			// 	width: "150px",
			// 	editable: false,
			// },
			{
				field: "actions",
				title: "Actions",
				show: true,
				// Two 32px icon buttons + 8px gap + 16px cell padding = 88px
				width: 88,
				fixedWidth: true,
				filterable: false,
				sortable: false,
				editable: false,
				cells: {
					data: (props: GridCustomCellProps) => {
						const user = props.dataItem as TraxUser;
						return (
							<GridTd tdProps={props.tdProps}>
								<div style={{ display: "flex", gap: "var(--kendo-spacing-2)" }}>
									<Button
										disabled={!canManageVendors}
										onClick={() => {
											onEdit(user);
										}}
										svgIcon={edit_05}
										variant={"tertiary"}
									/>
									<Button
										disabled={!canManageVendors}
										onClick={() => {
											onDelete(user);
										}}
										svgIcon={trash_01}
										variant={"dangerTertiary"}
									/>
								</div>
							</GridTd>
						);
					},
				},
			},
		],
		[onEdit, onDelete, canManageVendors],
	);

	return columns;
};
